import { Select as MantineSelect, Group, Radio } from '@mantine/core';
import '../styles/components/select.css';

const MantineSelectBox = ({
  options = [],
  leftIcon,
  children,
  onChange,
  value,
  width = '100px',
  height = '50px',
  style,
  zIndex,
  withinPortal,
  ...props
}) => {
  const defaultText = children || '선택하세요';

  const selectData = options.map(option => ({
    value: option.value,
    label: option.label,
  }));

  const renderSelectOption = ({ option, checked }) => (
    <Group gap="xs" style={{ padding: '8px 12px' }}>
      <Radio checked={checked} onChange={() => {}} color="green" size="sm" />
      <span style={{ color: '#333', fontSize: '16px' }}>{option.label}</span>
    </Group>
  );

  const comboboxProps = {};
  if (withinPortal !== undefined) {
    comboboxProps.withinPortal = withinPortal;
  }
  if (zIndex !== undefined) {
    comboboxProps.zIndex = zIndex;
  }
  if (withinPortal || zIndex) {
    comboboxProps.position = 'bottom-start';
  }

  return (
    <MantineSelect
      className="custom-mantine-select"
      data={selectData}
      placeholder={defaultText}
      value={value}
      onChange={onChange}
      {...(Object.keys(comboboxProps).length > 0 && { comboboxProps })}
      styles={{
        root: {
          width: width,
          height: height,
          ...style,
        },
        input: {
          height: height,
          textAlign: leftIcon ? 'left' : 'center',
          border: '1px solid #ABABAB',
          borderRadius: '3px',
          fontSize: '16px'
        },
        rightSection: {
          display: 'none !important',
        },
        dropdown: {
          marginTop: '5px',
          border: '2px solid #48B41A',
          borderRadius: '3px',
          minWidth: '135px',
          ...(zIndex && { zIndex: zIndex }),
        },
        option: {
          padding: 0,
          '&:hover': {
            backgroundColor: '#f5f5f5',
          },
        },
      }}
      renderOption={renderSelectOption}
      {...props}
    />
  );
};

export default MantineSelectBox;